var YouboraObject = require('../object')
var Log = require('../log')

var prefix = 'youbora'

/**
 * This class manages data sotrage in the browser memory.
 *
 * @extends youbora.Emitter
 * @memberof youbora
 */
var YouboraStorage = YouboraObject.extend(
  /** @lends youbora.YouboraStorage.prototype */
  {
    /**
     * Saves in localStorage or equivalent
     *
     * @param {string} key Key of the value. 'youbora.' will be appended.
     * @param {string} value Value.
     */
    setLocal: function (key, value) {
      if (!localStorage) {
        Log.error('Youbora Infinity needs localStorage which is not supported by your browser.')
        // TO-DO: develop alternative based on cookies
      } else {
        try {
          return localStorage.setItem('youbora.' + key, value)
        }
        catch (err) {
          Log.error('Youbora Infinity needs localStorage which is not supported by your browser.')
        }
      }
    },

    /**
     * Reads from localStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */
    getLocal: function (key) {
      if (!localStorage) {
        Log.error('Youbora Infinity needs localStorage which is not supported by your browser.')
        // TO-DO: develop alternative based on cookies
      } else {
        try {
          return localStorage.getItem(prefix + '.' + key)
        } catch (err) {
          Log.error('Youbora Infinity needs localStorage which is not supported by your browser.')
        }
      }
    },

    /**
     * Saves in sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     * @param {string} value Value.
     */
    setSession: function (key, value) {
      if (!sessionStorage) {
        Log.error('Youbora Infinity needs sessionStorage which is not supported by your browser.')
        // TO-DO: develop alternative based on cookies
      } else {
        try {
          return sessionStorage.setItem(prefix + '.' + key, value)
        } catch (err) {
          Log.error('Youbora Infinity needs sessionStorage which is not supported by your browser.')
        }
      }
    },

    /**
     * Reads from sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */
    getSession: function (key) {
      if (!sessionStorage) {
        Log.error('Youbora Infinity needs sessionStorage which is not supported by your browser.')
        // TO-DO: develop alternative based on cookies
      } else {
        try {
          return sessionStorage.getItem(prefix + '.' + key)
        } catch (err) {
          Log.error('Youbora Infinity needs sessionStorage which is not supported by your browser.')
        }
      }
    }
  }
)

module.exports = YouboraStorage



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/plugin/storage.js
// module id = 25
// module chunks = 0